import { Grid } from '@mui/material';
import { Formik } from 'formik';
import { DashboardTitle } from 'components/Titles';
import { FC, useEffect, useState } from 'react';
import { advertisementSignUpValidation } from 'schemas';
import { AdvertisementSignUpForm } from 'components/Forms';
import { AdvertisementService, PartnerService } from 'services';
import { useHistory } from 'react-router-dom';

interface IAdvertisement {
  title: string;
  partner: string | null | undefined;
  url: string;
  image: string;
}

const initialValues = {
  partner: '',
  title: '',
  image: '',
  url: '',
};

export const AdvertisementSignUp: FC = () => {
  const history = useHistory();
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string>('');
  const [success, setSuccess] = useState<string>('');
  const [partners, setPartners] = useState<IAdvertisement>(initialValues);

  useEffect(() => {
    getPartners();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getPartners = () => {
    PartnerService.getAllPartners()
      .then((response) => {
        const options: any = {};
        response?.data?.list?.forEach((partner: any) => {
          options[partner._id] = partner.socialReason;
        });
        setPartners(options);
      })
      .catch((error) => {
        setSuccess('');
        setError('Não foi possível listar os parceiros');
      });
  };

  const handleSubmit = async (values: IAdvertisement, { resetForm }: any) => {
    const isValid = await advertisementSignUpValidation.isValid(values);

    if (isValid) {
      setLoading(true);
      if (!values.partner || values.partner === '') {
        delete values.partner;
      }
      AdvertisementService.createUpdateAdvertisement(values)
        .then(
          () => {
            setError('');
            setSuccess('Anúncio cadastrado com sucesso');
            resetForm();
            setTimeout(() => history.goBack(), 3000);
          },
          ({ response }) => {
            setSuccess('');
            setError(response.data.error);
          }
        )
        .finally(() => {
          setLoading(false);
        });
    }
  };

  return (
    <Grid container>
      <Grid item xs={12}>
        <DashboardTitle title="GESTÃO DE ANÚNCIOS" />
      </Grid>
      <Grid item xs={12}>
        <Formik
          initialValues={initialValues}
          validationSchema={advertisementSignUpValidation}
          onSubmit={handleSubmit}
        >
          <AdvertisementSignUpForm
            loading={loading}
            success={success}
            error={error}
            partners={partners}
          />
        </Formik>
      </Grid>
    </Grid>
  );
};

